import { AnyObj } from '../../../../../typescript';
import { tryJsonParse } from '../../../../../utils';
import { StudioVisualizationType } from '../../visualizations';
import { DEFAULT_LAYOUT_CONFIG, type LayoutConfig, LayoutItem } from '../models';

const getSafeLayoutConfig = (layoutConfigStr: string): LayoutConfig => {
    const { parsedJson } = tryJsonParse<LayoutConfig>(layoutConfigStr);
    if (!parsedJson) return DEFAULT_LAYOUT_CONFIG;

    if (!parsedJson.lg) {
        parsedJson['lg'] = [];
    }

    if (!parsedJson.base) {
        parsedJson['base'] = [];
    }

    return parsedJson;
};

const VISUALIZATION_TYPES = Object.values(StudioVisualizationType);
const layoutItemIsViz = (value: any): value is StudioVisualizationType => {
    return VISUALIZATION_TYPES.includes(value);
};

/**
 * Given a layout config and a list of visualizations,
 * find the top visualization in the layout and return
 * it's corresponding visualization data
 **/
const findTopVisualization = <T extends AnyObj>(
    layoutConfig: LayoutConfig,
    visualizations: T[],
    lookUpKey: keyof T,
) => {
    let topItem: LayoutItem | undefined;

    for (const item of layoutConfig.lg) {
        if (item.data.type === 'markdown') continue;

        if (
            !topItem ||
            item.y < topItem.y || // Prioritize lower y
            (item.y === topItem.y && item.x < topItem.x) // Break tie with x
        ) {
            topItem = item;
        }
    }

    const index = visualizations.findIndex(viz => viz[lookUpKey] === topItem?.data?.id);
    return { topMostVisualization: visualizations[index], index };
};

export { findTopVisualization, getSafeLayoutConfig, layoutItemIsViz };
